import React, { useState } from 'react';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 1,
        paritialVisibilityGutter: 0
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 1,
        paritialVisibilityGutter: 0
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        paritialVisibilityGutter: 0
    }
};

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
    borderRadius: '0.8rem'
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .0)',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
    backgroundColor: '#79A9AF',
    borderRadius: '0rem 0rem 0.8rem 0.8rem'
}));

const accordionContent = [
    {
        name: "products",
        summary: 'Product & Service Providers',
        details: "To care for your clients, you need best-in-class resource partners to offer products consistent with your advice. But how do you know what options are right for them? As part of the KA network, we'll introduce you to our carefully selected, industry-leading resource partners so you can offer the resources that will align with your clients' values and needs."
    },
    {
        name: "prospects",
        summary: "Prospects & Clients",
        details: "Integrating your faith into your practice doesn't have to mean you won't find enough interested clients to grow your business. We have developed thousands of prospects who are hungry for biblical financial expertise through our consumer ministry, FaithFi. When you become a Certified Kingdom Advisor®, this growing market segment turns to you as the one to meet their needs."
    },
    {
        name: "firms",
        summary: "Large Financial Firms",
        details: "To serve your clients well, you need to work for a firm that supports faith-aligned advice. We partner with large financial firms across the country, equipping them with the training and resources you need to successfully integrate your faith into your practice. When you work in a firm that has approved the CKA® designation for use, you're fully prepared and encouraged to serve your clients with values-based financial advice."
    },
    {
        name: "universities",
        summary: "Universities",
        details: "When it's time to add new professionals to your team, it can be hard to find young advisors who are trained to give biblical financial advice. Kingdom Advisors partners with the Ron Blue Institute and financial planning programs in Christian universities and colleges across the country. As part of our network, you'll be introduced to and can hire talented graduates who are prepared to integrate faith from the start of their careers."
    },
    {
        name: "ministries",
        summary: "Ministries",
        details: "When you run a Christian financial practice, your clients look to you to help them activate generosity. We introduce you to a curated network of difference-making ministries so you can confidently bring your clients the giving opportunities they're looking for."
    },
]

export default function HomePageAccordion() {
    const [expanded, setExpanded] = useState(accordionContent[0].name);

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <div className='' style={{ backgroundColor: '#f0f0f0' }}>
            <div className='mx-auto max-w-7xl px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-8'>
                <div className='mx-auto w-full'>
                    <Carousel
                        partialVisbile
                        containerclassName='w-full my-5'
                        responsive={responsive}
                        swipeable={false}
                        draggable={false}
                        autoPlay={true}
                        infinite={true}
                        autoPlaySpeed={3000}
                    >
                        <div className='px-2 cursor-pointer'>
                            <img
                                className='w-full h-full'
                                src='/static/images/home-page-accordion/homepagecarousel1.jpg'
                            />
                        </div>
                        <div className='px-2 cursor-pointer'>
                            <img
                                className='w-full h-full'
                                src='/static/images/home-page-accordion/homepagecarousel2.jpg'
                            />
                        </div>
                        <div className='px-2 cursor-pointer'>
                            <img
                                className='w-full h-full'
                                src='/static/images/home-page-accordion/homepagecarousel3.jpg'
                            />
                        </div>
                        <div className='px-2 cursor-pointer'>
                            <img
                                className='w-full h-full'
                                src='/static/images/home-page-accordion/homepagecarousel4.jpg'
                            />
                        </div>
                        <div className='px-2 cursor-pointer'>
                            <img
                                className='w-full h-full'
                                src='/static/images/home-page-accordion/homepagecarousel5.jpg'
                            />
                        </div>
                    </Carousel>
                </div>
                <div className='mx-auto w-full my-5 space-y-3'>
                    {accordionContent.map((item, index) => (
                        <Accordion key={index} expanded={expanded === item.name} onChange={handleChange(item.name)}>
                            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                <Typography className='text-gray-600 text-lg font-bold'>
                                    {item.summary}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails className='flex  flex-col xl:flex-row   '>
                                <Typography className=' text-white  lg:w-full '>
                                    {item.details}
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </div>
            </div>
        </div>
    )
}
